import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { AppBar, Avatar, Box, Button, IconButton, Stack, Typography, } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import imgLogoDetranPortal from '../../assets/images/logo-detran-portal.png';
import { Colors } from '../../themes/theme';
import { SidebarMenu } from '../SidebarMenu';
import { useAuth } from '../../hooks/useAuth';
import PageTitle from '../PageTitle';
var Header = function () {
    var _a = useAuth(), userInfo = _a.userInfo, logout = _a.logout;
    var location = useLocation();
    var navigate = useNavigate();
    // Verifica se estamos na rota raiz
    var isHome = location.pathname === '/';
    var avatarLetter = useMemo(function () { return ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.nome) ? userInfo.nome.charAt(0).toUpperCase() : ''); }, [userInfo]);
    var handleBack = function () {
        navigate(-1);
    };
    return (_jsxs(AppBar, { position: "static", sx: { bgcolor: Colors.AZUL_GOV, boxShadow: 0 }, children: [_jsx(Box, { sx: { height: '1rem', bgcolor: Colors.AZUL_GOV } }), _jsx(Box, { sx: { backgroundColor: 'white' }, children: _jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", spacing: 2, px: 2, children: [_jsx(Link, { to: "/", style: { textDecoration: 'none', cursor: 'pointer' }, children: _jsx("img", { src: imgLogoDetranPortal, alt: "Detran MT Portal de Credenciamento", style: { height: '4rem', width: 'auto', margin: '0.3rem' } }) }), avatarLetter && (_jsxs(Box, { sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                mr: 3,
                            }, children: [_jsx(Avatar, { sx: {
                                        bgcolor: 'primary.main',
                                        color: 'white',
                                    }, children: avatarLetter }), _jsx(Button, { onClick: logout, sx: {
                                        textTransform: 'none',
                                        mt: 0.5,
                                        fontSize: '0.75rem',
                                        color: Colors.AZUL_GOV,
                                    }, children: "Sair" })] }))] }) }), _jsxs(Stack, { alignItems: "center", justifyContent: "space-between", direction: "row", sx: { height: '3rem', borderBottom: '1px solid rgba(255,255,255,0.2)' }, px: 2, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center' }, children: [_jsxs(Button, { onClick: function () { return navigate('/'); }, sx: {
                                    color: 'white',
                                    textTransform: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderBottom: isHome ? '2px solid white' : 'none',
                                }, children: [_jsx(HomeIcon, {}), _jsx(Typography, { variant: "body1", sx: { ml: 1 }, children: "IN\u00CDCIO" })] }), location.pathname !== '/' && (_jsx(IconButton, { sx: { color: 'white', ml: 1 }, onClick: handleBack, children: _jsx(ArrowBackIcon, {}) }))] }), _jsx(PageTitle.Portal, { defaultTitle: "DETRAN MT - Portal de Credenciamento" }), _jsx(SidebarMenu, {})] })] }));
};
export default Header;
